// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.css
// module id = 336
// module chunks = 50